export const downloadFromUrl = (url: string, filename?: string): void => {
  const a = document.createElement('a');
  a.href = url;
  if (filename) {
    a.download = filename;
  }
  a.target = '_blank';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / (k ** i)).toFixed(2))} ${sizes[i]}`;
};

export const extractFilename = (contentDisposition?: string, url?: string): string => {
  if (contentDisposition) {
    const regex = /filename="(.+)"/;
    const match = regex.exec(contentDisposition);
    if (match?.[1]) {
      return match[1];
    }
  }

  const urlMatch = url ? /[^/]+$/.exec(url) : null;
  if (urlMatch?.[0]) {
    return urlMatch[0];
  }

  const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
  return `bulk_download_${timestamp}.zip`;
};

export const isDownloadSupported = (): boolean => {
  const a = document.createElement('a');
  return typeof a.download !== 'undefined';
};

export const fallbackDownload = (url: string): void => {
  window.open(url, '_blank');
};

export const download = (url: string, filename?: string): void => {
  if (isDownloadSupported()) {
    downloadFromUrl(url, filename);
  } else {
    fallbackDownload(url);
  }
};